import { render } from "./FooterNav.vue?vue&type=template&id=5b206f7c&scoped=true"
import script from "./FooterNav.vue?vue&type=script&lang=js"
export * from "./FooterNav.vue?vue&type=script&lang=js"

import "./FooterNav.vue?vue&type=style&index=0&id=5b206f7c&scoped=true&lang=css"
import "./FooterNav.vue?vue&type=style&index=1&id=5b206f7c&scoped=true&lang=css"

import exportComponent from "/Users/ezink/Downloads/海/vue-antd-tool-web 2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b206f7c"]])

export default __exports__